import firebase from "firebase/app";
import "firebase/firestore";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "src/redux";
import { validate } from "../../util/types";
import { tAccountType } from "../company/types";
import { tReduxAction } from "../types";
export const fetchBrandProducts = (
  myCompanySnapshot: firebase.firestore.QuerySnapshot,
  myAccountType: tAccountType,
): tReduxAction => {
  return (dispatch) => {
    try {
      if (myAccountType === "brand") {
        dispatch({
          type: "SET_BRAND_PRODUCTS",
          products: myCompanySnapshot.docs.map((product) => {
            return { ...validate("tProduct")(product.data()), uid: product.id };
          }),
        });
      }
      dispatch({
        type: "SET_LOADING_PRODUCT",
        loading: false,
      });
    } catch (error) {
      console.warn(error);
    }
    return undefined;
  };
};

export const useFetchProducts = (): void => {
  const dispatch = useAppDispatch();
  const aCompanyRefPath = useSelector(({ UserReducer }) => UserReducer.profile.companyRefPath);
  const aAccountType = useSelector(({ UserReducer }) => UserReducer.profile.accountType);

  useEffect(() => {
    if (!aCompanyRefPath) {
      return undefined;
    }

    dispatch({
      type: "SET_LOADING_PRODUCT",
      loading: true,
    });

    return firebase
      .firestore()
      .doc(`${aCompanyRefPath}`)
      .collection("products")
      .orderBy("timeCreated")
      .onSnapshot((myCompanySnapshot) => {
        dispatch(fetchBrandProducts(myCompanySnapshot, aAccountType));
      });
  }, [aCompanyRefPath, aAccountType, dispatch]);
};
